module.exports = "/location-inactive-warning-007df52e38c3478e7fc83445fe0d6bff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Map/MapComponents/LocationMarker/icons/location-inactive-warning.svg
// module id = YI/7
// module chunks = 4